import { useState } from "react"

export default function Cards(props){

    let [show,setShow] = useState("hidden");


    return(
        <div className="card" onMouseEnter={()=>setShow("")} onMouseLeave={()=>setShow("hidden")} onClick={()=>props.selectedPage(props.movieId)}>
            <img src={props.picture} alt={props.movieName}/>
            <div className={"details "+show}>
                <p className="movieName">{props.movieName}</p>
                <hr/>
                <p>{props.desc}</p>
            </div>
        </div>
    )
}